/**
 * Sucht nach allen Auflagen eines Betriebes und hängt die Suchparameter als Queryparameter an.
 * Für die Auswertungen von Auflagen.
 * @param betriebId id des Betriebs
 * @param params JSON base64 codiert als String
 * @returns {String}
 */
export function getAuflagenSearchEndpoint(betriebId, params) {
    return "/betrieb/" + betriebId + "/auflage/search" + (params ? "?" + params : "");
}
